import { EditOutlined } from "@mui/icons-material";
import { Box, Checkbox, FormControlLabel, Grid } from "@mui/material";
import Images from "assets/images";
import { BackButton, CardBox, CustomButton } from "components";
import Image from "components/common/Image";
import { errorAlert } from "helpers/alerts";
import { validatePermission } from "helpers/authentication";
import { currencyFormatter } from "helpers/util";
import React, { useEffect } from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setCurrentPINProduct, setCurrentPINSegment, setJustProducts, setPINProducts, setPINSegments } from "redux/slices/client/bagSlice";
import { getAllBagPINProductsService, getBagPINProductsService, getBagPINSegmentsService } from "services/client/bagService";

const BagPINScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { hoster } = useSelector(store => store.session);
  const { currentCommerce } = useSelector((store) => store.commerces);
  const currentBag = currentCommerce.bags.find(bag => bag.type === 'PDS');
  const {
    justProducts,
    pinSegments,
    pinProducts,
    currentPINSegment,
    currentPINProduct
  } = useSelector((store) => store.bags);

  useEffect(() => {
    getBagPINSegmentsService(currentBag.id).then(list => {
      dispatch(setPINSegments(list));
    }).catch(error => errorAlert(error))
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (justProducts) {
      getAllBagPINProductsService(currentBag.id).then(list => {
        dispatch(setPINProducts(list));
      }).catch(error => errorAlert(error))
    } else {
      if (currentPINSegment)
        getBagPINProductsService(currentBag.id, currentPINSegment.id).then(list => {
          dispatch(setPINProducts(list));
        }).catch(error => errorAlert(error))
    }
    // eslint-disable-next-line
  }, [currentBag, currentPINSegment, justProducts]);


  const handlerClickSegment = (segment) => {
    if (segment.id !== currentPINSegment?.id) {
      batch(() => {
        dispatch(setCurrentPINSegment(segment));
        dispatch(setCurrentPINProduct());
      })
    }
  };

  const handlerClickProduct = (product) => {
    if (product.id !== currentPINProduct?.id) {
      dispatch(setCurrentPINProduct(product));
    }
  };

  return (
    <Box mt={2} >
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <div>
          <BackButton click={() => navigate('/cliente/comercios')} />
        </div>
        <div className="container-title">
          <div className="commerce">{currentCommerce.username} </div>
          <div className="bag">{currentBag.username} </div>
        </div>
        <div >
          {
            hoster?.id != currentCommerce._id && <CustomButton
              dark={true}
              icon={<EditOutlined />}
              name={'Administrar'}
              click={() => navigate(justProducts ? "productos" : "segmentos")}

            />
          }

        </div>
      </Grid>
      <Box mt={2} />
      {
        !justProducts && (
          <CardBox
            name={"Segmentos"}
            values={pinSegments}
            handleSelect={handlerClickSegment}
            isSelect={currentPINSegment?.id}
            buttons={[
              {
                type: "custom",
                element: <FormControlLabel
                  label={'Ver solo produtos'}
                  control={
                    <Checkbox
                      checked={justProducts}
                      checkedIcon={<Image src={Images.icon.check_square} />}
                      icon={<Image src={Images.icon.uncheck_square} />}
                      onChange={(e) => {
                        dispatch(setJustProducts(e.target.checked))
                      }}
                    />
                  }
                />
              },
            ]}
            formatter={({ idSegment: item }) => ({
              ...item,
              image: `/v3/file/${item.fd}/`,
            })}
          />
        )
      }
      {
        (justProducts || currentPINSegment) && (
          <CardBox
            name={"Servicios"}
            values={pinProducts?.filter(({ state }) => state)}
            handleSelect={handlerClickProduct}
            isSelect={currentPINProduct?.id}
            buttons={[
              hoster?.id != currentCommerce._id && !justProducts && {
                icon: <EditOutlined />,
                key: "products",
                name: "Administrar",
                click: () => navigate("productos"),
              },
              justProducts && {
                type: "custom",
                element: <FormControlLabel
                  label={'Ver solo produtos'}
                  control={
                    <Checkbox
                      checked={justProducts}
                      checkedIcon={<Image src={Images.icon.check_square} />}
                      icon={<Image src={Images.icon.uncheck_square} />}
                      onChange={(e) => {
                        dispatch(setJustProducts(e.target.checked))
                      }}
                    />
                  }
                />
              },
            ]}
            formatter={({ idProduct: item, commission }) => ({
              ...item,
              commission,
              image: `/v3/file/${item.fd}/`,
            })}
            element={({ commission }) => (
              validatePermission("comercios", "comisiones", ["ver"]) && <div style={{ textAlign: 'center' }}>Comisión: {commission || 0}%</div>
            )}
          />
        )
      }
    </Box >
  );
};

export default BagPINScreen;
